import React from "react";
import { Link } from "react-router-dom";
import { Plus, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCart } from "@/context/CartContext";
import { money } from "@/lib/api";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const discount = product.mrp && product.mrp > product.price
    ? Math.round(((product.mrp - product.price) / product.mrp) * 100)
    : 0;

  return (
    <div className="group bg-card border border-border rounded-lg overflow-hidden rb-lift flex flex-col" data-testid={`product-card-${product.product_id}`}>
      <Link to={`/product/${product.product_id}`} className="block relative aspect-square bg-muted overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy"
             className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        {discount > 0 && (
          <span className="absolute top-2 left-2 bg-primary text-primary-foreground text-xs font-bold px-2 py-1 rounded-md font-mono-points">-{discount}%</span>
        )}
      </Link>
      <div className="p-3 flex flex-col flex-1">
        <div className="text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">{product.brand}</div>
        <div className="font-heading font-semibold text-sm leading-tight mt-0.5 line-clamp-2">{product.name}</div>
        <div className="text-xs text-muted-foreground mt-1">{product.pack_size}</div>
        <div className="mt-auto pt-3 flex items-end justify-between gap-2">
          <div>
            <span className="font-heading font-bold text-lg">{money(product.price)}</span>
            {discount > 0 && <span className="ml-1 text-xs text-muted-foreground line-through">{money(product.mrp)}</span>}
          </div>
          <Button size="sm" data-testid={`add-to-cart-${product.product_id}`}
                  onClick={() => { add(product); toast.success(`${product.name} added to cart`); }}>
            <Plus size={16} />
          </Button>
        </div>
        {product.eligible_for_points && (
          <div className="mt-2"><Badge variant="secondary" className="text-[10px] gap-1"><Check size={10} /> RicePoints eligible</Badge></div>
        )}
      </div>
    </div>
  );
}
